import script from "./IconRateType.vue?vue&type=script&lang=js"
export * from "./IconRateType.vue?vue&type=script&lang=js"

const __exports__ = script;

export default __exports__